import { Input } from "../../ui/input";
import { Label } from "../../ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../ui/select";
import { ConfigFieldsProps } from "./types";

export function CalendarConfig({
  editedComponent,
  updateConfig,
  calendarIntegrations,
}: ConfigFieldsProps) {
  return (
    <>
      <div className="space-y-2">
        <Label htmlFor="calendarTitle">Título do Calendário</Label>
        <Input
          id="calendarTitle"
          type="text"
          value={editedComponent.config.title || "Calendário"}
          onChange={(e) => updateConfig("title", e.target.value)}
          placeholder="Calendário"
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="viewMode">Modo de Visualização</Label>
        <Select
          value={editedComponent.config.viewMode || "month"}
          onValueChange={(value) => updateConfig("viewMode", value)}
        >
          <SelectTrigger id="viewMode">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="month">Mês</SelectItem>
            <SelectItem value="week">Semana</SelectItem>
            <SelectItem value="day">Dia</SelectItem>
          </SelectContent>
        </Select>
      </div>

      <div className="flex items-center gap-2">
        <input
          type="checkbox"
          id="calendarEditable"
          checked={editedComponent.config.editable !== false}
          onChange={(e) => updateConfig("editable", e.target.checked)}
          className="w-4 h-4 rounded"
        />
        <Label htmlFor="calendarEditable" className="cursor-pointer">
          Permitir adicionar/editar eventos
        </Label>
      </div>

      <div className="p-4 bg-accent border border-primary/20 rounded-md">
        <p className="text-sm">
          <strong>📅 Sobre o Calendário:</strong>
        </p>
        <p className="text-xs text-muted-foreground mt-2">
          Use o calendário para gerenciar eventos e compromissos. Os eventos são
          salvos automaticamente e podem ser visualizados por dia, semana ou
          mês.
        </p>
      </div>

      {/* Google Calendar sync */}
      <div className="p-4 bg-gradient-to-br from-blue-50 to-indigo-50 dark:from-blue-950 dark:to-indigo-950 border-2 border-blue-500/30 rounded-lg space-y-3">
        <div>
          <h3 className="text-sm font-semibold flex items-center gap-2">
            📅 Google Calendar — selecione a integração
          </h3>
          <p className="text-xs text-muted-foreground mt-1">
            Escolha uma integração criada em Configurações → Integrações
          </p>
        </div>

        {calendarIntegrations.length === 0 ? (
          <div className="p-3 bg-amber-50 dark:bg-amber-950 border border-amber-200 dark:border-amber-800 rounded text-xs text-amber-700 dark:text-amber-300 space-y-1">
            <p className="font-semibold">
              ⚠️ Nenhuma integração de Google Calendar encontrada
            </p>
            <p>
              Vá em <strong>Configurações → Integrações</strong> e crie uma
              integração do tipo Google Calendar.
            </p>
          </div>
        ) : (
          <div className="space-y-1.5">
            <Label htmlFor="gcalIntegration" className="text-xs">
              Integração
            </Label>
            <Select
              value={
                editedComponent.config.googleCalendar?.integrationId ||
                "__none__"
              }
              onValueChange={(value) =>
                updateConfig("googleCalendar", {
                  ...editedComponent.config.googleCalendar,
                  integrationId:
                    value === "__none__" ? undefined : value,
                })
              }
            >
              <SelectTrigger id="gcalIntegration" className="text-xs">
                <SelectValue placeholder="Selecione uma integração (opcional)" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="__none__">
                  Nenhuma (apenas eventos locais)
                </SelectItem>
                {calendarIntegrations.map((i) => (
                  <SelectItem key={i.id} value={i.id}>
                    {i.name}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
            <p className="text-xs text-muted-foreground">
              Gerencie seus calendários em{" "}
              <strong>Configurações → Integrações</strong>.
            </p>
          </div>
        )}
      </div>
    </>
  );
}
